import { call, select } from "redux-saga/effects";

import type {
  PostApiCommitCreateRequestBody,
  PostApplicationCommitCreateRequestBody,
} from "@superblocksteam/schemas";
import type { VersionedEntityType } from "@superblocksteam/shared";

import { getSagaErrorMessage } from "core/utils/sagaError";
import { Variant } from "legacy/components/ads/common";
import { Toaster } from "legacy/components/ads/Toast";
import { getCurrentBranch } from "legacy/selectors/editorSelectors";

import { createSaga } from "../../../utils/saga";
import { resetEditor as resetEditorCall } from "../client";
import slice from "../slice";

function* resetEditorSaga({
  entityId,
  entityType,
  commitId,
}: {
  entityId: string;
  entityType: VersionedEntityType;
  commitId: string;
}): Generator<
  any,
  PostApplicationCommitCreateRequestBody | PostApiCommitCreateRequestBody,
  any
> {
  const branch: ReturnType<typeof getCurrentBranch> =
    yield select(getCurrentBranch);
  const result:
    | PostApplicationCommitCreateRequestBody
    | PostApiCommitCreateRequestBody = yield call(
    resetEditorCall,
    entityId,
    entityType,
    branch?.name,
    commitId,
  );
  return result;
}

const resetEditor = createSaga(resetEditorSaga, resetEditorSaga.name, {
  sliceName: slice.name,
});

slice.saga(resetEditor, {
  start(state) {
    state.loading.commits = true;
  },
  success(state) {
    state.loading.commits = false;
  },
  error(state, { payload }) {
    state.error = { autosaves: payload, commits: payload };
    Toaster.show({
      text: getSagaErrorMessage(payload),
      variant: Variant.danger,
    });
    state.loading.commits = false;
  },
});
